(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wubs-sti-bundle"] && !Shopify.designMode) return;
  try {
    (() => {
    const initBundleOffer = (bundle) => {
      if (bundle.dataset.initialized === 'true') return;
      bundle.dataset.initialized = 'true';

      const button = bundle.querySelector('[data-wubs-bundle-add]');
      const status = bundle.querySelector('[data-wubs-bundle-status]');
      const bundleVariantId = Number(bundle.dataset.bundleVariantId);
      const isAvailable = bundle.dataset.available === 'true';
      const errorText = bundle.dataset.error || '';
      const rootUrl = (bundle.dataset.rootUrl || '/').replace(/\/$/, '');

      if (!button) return;

      const buildUrl = (path) => `${rootUrl}${path.startsWith('/') ? path : `/${path}`}`;

      const openCart = () => {
        try {
          if (window.WubsCartDrawer && typeof window.WubsCartDrawer.open === 'function') {
            window.WubsCartDrawer.open();
            return true;
          }
        } catch (error) {}

        try {
          if (window.wubsCartDrawerOpen) {
            const keys = Object.keys(window.wubsCartDrawerOpen);
            for (const key of keys) {
              if (typeof window.wubsCartDrawerOpen[key] === 'function') {
                window.wubsCartDrawerOpen[key]();
                return true;
              }
            }
          }
        } catch (error) {}

        try {
          document.dispatchEvent(new CustomEvent('wubs:cart-open', { detail: { mode: 'drawer' } }));
          return true;
        } catch (error) {}

        return false;
      };

      button.addEventListener('click', async () => {
        if (!isAvailable || !bundleVariantId || button.getAttribute('aria-busy') === 'true') return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (status) status.textContent = '';

        try {
          const response = await fetch(buildUrl('/cart/add.js'), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: bundleVariantId, quantity: 1 }] })
          });
          if (!response.ok) throw new Error('Cart add failed');
          await response.json();
          if (!openCart()) window.location.href = buildUrl('/cart');
        } catch (error) {
          if (status) status.textContent = errorText;
        } finally {
          button.removeAttribute('aria-busy');
          button.disabled = !isAvailable;
        }
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-wubs-bundle-offer]').forEach(initBundleOffer);
    };

    initAll();
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
